import _archiveEntry from "./archivers/archive-entry";
import _zipArchiveEntry from "./archivers/zip/zip-archive-entry";
import _archiveOutputStream from "./archivers/archive-output-stream";
import _zipArchiveOutputStream from "./archivers/zip/zip-archive-output-stream";
var exports = {};

/**
 * node-compress-commons
 *
 * Copyright (c) 2014 Chris Talkington, contributors.
 * Licensed under the MIT license.
 * https://github.com/archiverjs/node-compress-commons/blob/master/LICENSE-MIT
 */
exports = {
  ArchiveEntry: _archiveEntry,
  ZipArchiveEntry: _zipArchiveEntry,
  ArchiveOutputStream: _archiveOutputStream,
  ZipArchiveOutputStream: _zipArchiveOutputStream
};
export default exports;
export const ArchiveEntry = exports.ArchiveEntry;